import { useQuery } from "@tanstack/react-query"
import { DeprecatedDeviceGet } from "../app/models/DeprecatedDevice"
import { digitalManagerApi } from "../services/api"

export function useDeprecatedDevices() {
  const { data: deprecatedDevicesList = [], isLoading: isLoadingDeprecatedDevices } =
    useQuery({
      queryKey: ["deprecatedDevices"],
      queryFn: () =>
        digitalManagerApi
          .get<DeprecatedDeviceGet[]>(`/deprecatedDevices`)
          .then((r) => r.data),
    })

  return {
    deprecatedDevicesList,
    isLoadingDeprecatedDevices,
  }
}
